import React, {useState, useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {ThemeContext, Icon} from '../';

const Button = (props) => {
  const {
    children,
    text,
    nested,
    expanded,
    center,
  } = props;
  const {primaryColor, secondaryColor} = useContext(ThemeContext);
  const [isExpanded, setExpanded] = useState(expanded);

  useEffect(() => {
    setExpanded(expanded);
  }, [expanded]);

  const clickHandler = (e) => {
    e.preventDefault();
    setExpanded(!isExpanded);
  };
  const areaClasses = classnames('collaplable__area', {
    collaplable__area_visible: isExpanded,
    collaplable__area_center: center,
  });
  const triggerClasses = classnames('collaplable__trigger', {
    open: isExpanded,
  });

  return (
    <div className="collaplable">
      <div
        className={triggerClasses}
        onClick={clickHandler}
        style={{color: nested ? secondaryColor : primaryColor}}
      >
        {text}
        <Icon
          color={nested ? secondaryColor : primaryColor}
          glyph="angle"
          iconSize="18"
        />
      </div>
      <div className={areaClasses}>
        {children}
      </div>
    </div>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
  ]).isRequired,
  text: PropTypes.string,
  nested: PropTypes.bool,
  expanded: PropTypes.bool,
  center: PropTypes.bool,
};

Button.defaultProps = {
  text: '',
  nested: false,
  expanded: false,
  center: false,
};

export default Button;
